export default __webpack_public_path__ + "//i/components/icon/svg//route-happy.svg";